import { Component, OnInit, Input, HostBinding } from '@angular/core';
import { ShoppingCartItem } from '../../_models/cart/shopping.cart.item';
import { CartService } from '../../_services/cart.service';
import { MainService } from '../../_services/main.service';

@Component({
  selector: 'app-item-count-small',
  templateUrl: './item-count-small.component.html',
  styleUrls: ['./item-count-small.component.scss']
})
export class ItemCountSmallComponent implements OnInit {
  @Input() sci: ShoppingCartItem;
  @Input() center: boolean;
  @Input() isCart: boolean;

  constructor(
    public mainService: MainService,
    public cartService: CartService
  ) { }

  ngOnInit() {

  }

  getPerQuantity(): number {
    if (this.sci?.ItemInfo?.Price?.SalesUnit > 1) {
      return this.sci.ItemInfo.Price.SalesUnit;
    }
    return 1;
  }

}
